export const ID = 'TOOLTIPS';

export const LOAD_TOOLTIP = `${ID}/LOAD_TOOLTIP`;
export const LOAD_TOOLTIP_COMPLETED = `${ID}/LOAD_TOOLTIP_COMPLETED`;
export const LOAD_TOOLTIP_FAILED = `${ID}/LOAD_TOOLTIP_FILED`;

export const MARK_TOOLTIP = `${ID}/MARK_TOOLTIP`;
export const MARK_TOOLTIP_COMPLETED = `${ID}/MARK_TOOLTIP_COMPLETED`;
export const MARK_TOOLTIP_FAILED = `${ID}/MARK_TOOLTIP_FAILED`;
